import { useInfiniteQuery } from "@tanstack/react-query";
import { GeneratedTextPage } from "./types/GeneratedTexts";

export const REEPRISE_LIST_QUERY_KEY = "reeprise-infinite-list-query";

const fetchGeneratedTextPage = async ({
  pageParam,
  signal,
}: {
  pageParam: string;
  signal: AbortSignal;
}) => {
  const res = await fetch(
    `/api/reeprise/generated_texts/${pageParam ? `?cursor=${pageParam}` : ""}`,
    { signal },
  );
  if (!res.ok) {
    throw new Error("could not fetch reeprises");
  }
  return (await res.json()) as GeneratedTextPage;
};

export function useGeneratedTextPaginatedList() {
  const paginatedGeneratedTextListQuery = useInfiniteQuery({
    queryKey: [REEPRISE_LIST_QUERY_KEY],
    queryFn: fetchGeneratedTextPage,
    initialPageParam: "",
    getNextPageParam: (lastPage) => lastPage.next,
    refetchInterval: (query) => {
      const results =
        query.state.data?.pages.flatMap((page) => page.results) ?? [];

      const isGeneratingText = results.some(
        (text) => text.status === "PENDING",
      );

      const waitingForPodcastAudio = results.some(
        (text) =>
          text.text_type === "PODCAST" &&
          // keep polling until a speech URL is present
          !text.speech,
      );

      if (isGeneratingText || waitingForPodcastAudio) {
        return 1000;
      }
      return false;
    },
    staleTime: 400,
  });

  return paginatedGeneratedTextListQuery;
}
